import { Box, Title, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/procurement/components/purchaseOrders/UpdateOrderModal/types'

const GeneralInformationStep: React.FC<WizardStepRenderParams<WizardData>> = ({
  data,
  onDataChanged,
}) => {
  return (
    <Box gap="s24">
      <Title
        description={i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.general_information.description'
        )}
        title={i18n.t(
          'procurement.purchase_orders.update_order_wizard.steps.general_information.title'
        )}
      />
      <Box gap="s24" paddingRight="s24">
        <TextField
          mandatory
          value={data.formattedPoNumber}
          label={i18n.t(
            'procurement.purchase_orders.update_order_wizard.steps.general_information.fields.formatted_po_number'
          )}
          onChange={(value) => onDataChanged({ ...data, formattedPoNumber: value })}
        />

        <TextField
          mandatory
          value={data.description}
          label={i18n.t(
            'procurement.purchase_orders.update_order_wizard.steps.general_information.fields.description'
          )}
          onChange={(value) => onDataChanged({ ...data, description: value })}
        />

        <TextField
          readonly
          value={data.url}
          label={i18n.t(
            'procurement.purchase_orders.update_order_wizard.steps.general_information.fields.url'
          )}
        />

        <TextArea
          value={data.additionalInformation ?? ''}
          label={i18n.t(
            'procurement.purchase_orders.update_order_wizard.steps.general_information.fields.additional_information'
          )}
          readonly
          minRows={2}
        />
      </Box>
    </Box>
  )
}

export default GeneralInformationStep
